$(document).ready(function() {
	if(!document.querySelector('.air-solution-select-condition')) return false;
	
	var conditionSelect = {
		root: document.querySelector('.air-solution-select-condition'),
		form: document.querySelector('.air-solution-select-condition form.search-common'),
		countryOrg: $("#cCountry").val(),
		searchAreaBtn : document.querySelector('.air-solution-select-condition .condition-toggle-btn'),
        resultWrap : document.querySelector('.air-search-result-area'),
        country : document.getElementById('country'),
        category : document.getElementById('category'),
		SubCategory : document.getElementById('SubCategory'),
		html : $(),
		mobileHtml: $(),
		listAmountDefault: 10,
		getData : new Array(),
		thisLine : 10,
		mobileIdx: 0,
		pcIdx: 0,
		mNewest : 'newest', 
		mOldest : 'oldest',
		country_m : $("#country_m").val(),
		resource_m : $("#resource_m").val(),
		title_m : $("#title_m").val(),
		path_m : $("#path_m").val(),
		regdate_m : $("#regdate_m").val(),
		init: function(){
			var $select = $(conditionSelect.form).find('select');
			if ($select.length > 0) {
			    chosenScrollInit();
			};
			conditionSelect.addEvent();
            $(conditionSelect.country).drawAjaxOptions({
                url: $(this).data('url'),
                setTarget: conditionSelect.category,
                //param: $('#cCountry'),
                addParam: [ $('#cCountry'), $('#cLocaleCode') ],
                callback: function () {
                	$("#category").val('all');
                	$("#category").trigger("chosen:updated");
                	$("#category").trigger('change');
                }
            });
            $(conditionSelect.category).drawAjaxOptions({
                url: $(this).data('url'),
				setTarget: conditionSelect.SubCategory,
				//param: $('#cCountry'),
				addParam: [ $('#cCountry'), $('#cLocaleCode') ],
                callback: function () {
                	if($("#category").val() == 'all'){
                		$("#SubCategory").prop('disabled', 'true');
                	}
                	$("#SubCategory").val('all');
                	$("#SubCategory").trigger("chosen:updated");
                }
            });
			
			// console.log("isMobile > "+isMobile);
			if(isMobile){
				conditionSelect.listAmountDefault = 10;
				conditionSelect.thisLine = 10;
				$("#size").val(conditionSelect.thisLine);
				// console.log("conditionSelect.thisLine > "+conditionSelect.thisLine);
			}
			
			if( $("#country").val() != null && $("#country").val() != ""){
				$("#country").trigger('change');
			}
		},
		
		submit: function(url, param){
			ajax.call(url, param, 'json', function(data){
				result.data (data, conditionSelect.thisLine);
				conditionSelect.paginationEvent();
			}, 'post', 'body');
		},
		addEvent: function(){
			var $formRoot = $(conditionSelect.form);
			// show hide search
			$(conditionSelect.searchAreaBtn).on('click',function(){
				var $this = $(this);
				var ariaExpd = $this.attr('aria-expanded');
				$this.parents('.air-solution-select-condition').toggleClass('form-close');
				if ( ariaExpd === 'true' ) {
					$this.find('.text-close').attr('aria-hidden', false);
					$this.find('.text-open').attr('aria-hidden', true);
				} else {
					$this.find('.text-close').attr('aria-hidden', true);
					$this.find('.text-open').attr('aria-hidden', false);
				}
				$this.attr('aria-expanded', ( ariaExpd === 'true' ) ? false : true );
			});
			// submit
			$formRoot.on('submit', function(e){
				conditionSelect.pcIdx = 1;
            	conditionSelect.mobileIdx = 1;
            	result.currentIdx = 1;
            	$("#from").val(1);
            	
				e.preventDefault();
				var url = $formRoot.attr('data-url');
				var param = $formRoot.serialize();
				conditionSelect.submit(url, param);
			});
			// reset
			$formRoot.find('.btn-area .btn-secondary').on('click',function(){
				$formRoot.find('.row input, .row select').val('');
				$("#category").val('all').prop('disabled', 'true');
				$('#country').val(conditionSelect.countryOrg);
				$formRoot.find('.row select').trigger("chosen:updated");
				// empty list
				$('.table-list tbody').empty();
				$('.list-mobile').empty();
				$(conditionSelect.resultWrap).find('.hidden-mobile, .visible-mobile, .pagination-wrap').addClass('air-hidden');
				
				if( $("#country").val() != null && $("#country").val() != ""){
					$("#country").trigger('change');
				}
				
				$("#SubCategory").prop('disabled', 'true');
        		$("#SubCategory").trigger("chosen:updated");
			});
			
			// LGEGMC-946
			$("#category").on({
				change: function(){
					setClassificationCode($("#category").val());
				}
			});
			
			$("#SubCategory").on({
				change: function(){
					setClassificationCode($("#SubCategory").val());
				}
			});
			// LGEGMC-946 End
			
			// 반응형 pagination 변경 20200720 모바일 시 닫힘 삭제
			// $(window).on('resize load', function(){
			// 	var checkWidthValue = window.matchMedia('(min-width: 768px)');
			// 	var $paginWrp = $('.pagination-wrap');
			// 	var $root = $(conditionSelect.root);
			// 	// console.log( checkWidthValue.matches);
			// 	if ( checkWidthValue.matches ) {
			// 		$paginWrp.find('.pagination').show().end().find('.expander').hide();
			// 		$root.removeClass('form-close'); // pc 에서 검색 열기
			// 	} else {
			// 		$paginWrp.find('.pagination').hide().end().find('.expander').show();
			// 		$root.addClass('form-close'); // pc 에서 검색 닫기
			// 	}
			// });
			
//			$('#country').change(function(e,objSel){
//				if( "GLOBAL" == objSel.selected){
//					$('#scrCatetory').hide();
//					$('#scrSubCatetory').hide();
//				}else{
//					$('#scrCatetory').show();
//					$('#scrSubCatetory').show();
//				}
//			});
			
			$('#numberManualsList').change(function(){
				var line = $(this).val();
                //result.listShow(conditionSelect.getData, line);
                conditionSelect.thisLine = line;
                
                $("#size").val(line);
                $formRoot.submit();
            });
			
            $('.filter-wrap input[type="radio"]').on('change',function(){
            	/*
                conditionSelect.getData = conditionSelect.getData.reverse();
                if ( $(this).attr('id') === 'radio-sort-new') {
                    $('.filter-wrap').removeClass('reverse');
                } else if ($(this).attr('id') === 'radio-sort-old') {
                    $('.filter-wrap').addClass('reverse');
				}
				result.listShow(conditionSelect.getData, conditionSelect.thisLine);
				*/
            	
            	if ( $(this).attr('id') === 'radio-sort-new') {
    				$("#sort").val(conditionSelect.mNewest);
                } else if ($(this).attr('id') === 'radio-sort-old') {
                	$("#sort").val(conditionSelect.mOldest);
    			}
    			
    			$formRoot.submit();
			});
            
            $("#select-sort").on("change",function(){
    			
    			if( $("#select-sort").val() == "newest"){
    				$("#sort").val(conditionSelect.mNewest);
    			}else{
    				$("#sort").val(conditionSelect.mOldest);
    			}
    			
    			$formRoot.submit();
    		});
			
			//mobile more
			$('.expander .btn').on('click',function(){
				conditionSelect.listAmountDefault = conditionSelect.listAmountDefault + 5;
				conditionSelect.thisLine = conditionSelect.listAmountDefault;
				$("#size").val(conditionSelect.thisLine);
				//result.listShow(conditionSelect.getData, conditionSelect.listAmountDefault);
				$formRoot.submit();
			});
		},
		paginationEvent : function(){
			result.$pgUl.find('button').off('click').on( 'click', function(e){
				e.preventDefault();
				var $this = $(this);
				result.currentIdx = Number($this.val()); // 3
				var page = (result.currentIdx * conditionSelect.thisLine) - conditionSelect.thisLine;
				conditionSelect.pcIdx =  page;
				// console.log( 'current index ', result.currentIdx);
				// console.log('current number ', conditionSelect.thisLine);
				// console.log('data length ', conditionSelect.getData.length);
				// console.log('data ', conditionSelect.getData);
				// console.log( 'page ', page);
				// console.log( 'pcIdx ', conditionSelect.pcIdx );
				//result.listShow(conditionSelect.getData, (conditionSelect.pcIdx + conditionSelect.thisLine) );
				$this.addClass('active').attr({'aria-label': 'page '+ result.currentIdx, 'aria-current': 'page' }).prop('disabled', true).parent('li').siblings('li').find('button').removeClass('active').removeAttr('aria-current').prop('disabled', false);
				$('.data-current-page').text($this.val());

				$("#from").val(result.currentIdx);
				var $evForm = $(conditionSelect.form);
				var url = $evForm.attr('data-url');
				var param = $evForm.serialize();
				conditionSelect.submit(url, param);
			});
			result.$pgWrap.find('.next, .prev').off('click').on( 'click', function(e){
				e.preventDefault();
				var isNext = $(this).is('.next');
				if ( isNext ) {
					result.currentIdx = Number(result.$pgUl.find('button').first().val()) + 5;
				} else {
					if( Number(result.$pgUl.find('button').first().val()) - 5 < 1){
						result.currentIdx = 1;
					}else{
						result.currentIdx = Number(result.$pgUl.find('button').first().val()) - 5;
					}
					
				}
				var page = (result.currentIdx * conditionSelect.thisLine) - conditionSelect.thisLine;
				conditionSelect.pcIdx =  page;
				// console.log('next current idx ', result.currentIdx);
				// console.log('pcIdx idx ', conditionSelect.pcIdx);
				result.listShow(conditionSelect.getData, (conditionSelect.pcIdx + conditionSelect.thisLine) );
				result.pagination();
				conditionSelect.paginationEvent();
				$('.data-current-page').text(result.$pgUl.find('button').first().val());
				
				$("#from").val(result.currentIdx);
				var $evForm = $(conditionSelect.form);
				var url = $evForm.attr('data-url');
				var param = $evForm.serialize();
				conditionSelect.submit(url, param);
			});
		}
	}
	var result = {
		currentIdx : 1,
		$pgWrap : $('.pagination-wrap'),
		$pgUl : $('.pagination-wrap .pagination ul'),
		getTotalNum : null,
		data : function (data, listAmount) {
			totalNum = data.totalNum;
			data = data.list;
			result.resogetTotalNum = totalNum;
			result.listShow(data, listAmount, totalNum);
			conditionSelect.getData = data;
			conditionSelect.thisLine = listAmount;
			var $list = $(conditionSelect.resultWrap);
			result.pagination();
			conditionSelect.paginationEvent();
			$list.find('.no-content').removeClass('air-show');
			$list.find('.hidden-mobile, .visible-mobile, .pagination-wrap').removeClass('air-hidden');
			// no-content
			// console.log('totalNum  ', totalNum);
			if( (totalNum === 0) || ( totalNum === undefined ) ){
				$list.find('.hidden-mobile, .visible-mobile, .pagination-wrap').addClass('air-hidden');
				$list.find('.no-content').addClass('air-show');
			}
		},
		pagination : function(){
			var $pgWrap	= result.$pgWrap,
				$pgUl	= result.$pgUl,
				$htmlLi	= $(),
				data = conditionSelect.getData,
				pageLength = Math.floor((result.resogetTotalNum-1) / conditionSelect.thisLine) + 1,
				i = result.currentIdx,
				f = result.currentIdx,
				v = 1,
				i2= 1;
				//v = result.currentIdx + 4;
			
				i = i - (i % 5) + ( (i % 5)==0?-4:1);
				v = i+4;
				i2 = i;

			//console.log("pageLength >> "+pageLength);
			//console.log("thisLine >> "+conditionSelect.thisLine);
			for(i;i<=pageLength;i++){
				if(i <= v ) {
					if ( i === result.currentIdx ) {
						$htmlLi = $htmlLi.add('<li><button type="button" value="'+i+'" aria-label="Page '+i+'" class="active" aria-current="page" disabled>'+i+'</button></li>');
					} else {
						$htmlLi = $htmlLi.add('<li><button type="button" value="'+i+'" aria-label="Page '+i+'">'+i+'</button></li>');
					}
				}
			}			
			// console.log($htmlLi);
			$pgUl.empty().append($htmlLi);
			
			//console.log(pageLength);
			if (pageLength >= 6 ) {
				$pgWrap.find('button.prev').prop("disabled", true);
				
				var las = pageLength - (pageLength % 5) + ( (pageLength % 5)==0?-4:1);
				if( i2 < las ){
					$pgWrap.find('button.next').prop("disabled", false);
					$pgUl.append('<li>...  <button type="button" value="'+pageLength+'" aria-label="Page '+pageLength+'">'+pageLength+'</button></li>');
				}else{
					$pgWrap.find('button.next').prop("disabled", true);
				}
			} else {
				$pgWrap.find('button.prev, button.next').prop("disabled", true);
			}
			if( f > 5 ) {
				$pgWrap.find('button.prev').prop("disabled", false);
			}
			
			//console.log("resogetTotalNum > "+pageLength +" : "+result.currentIdx);
			if( pageLength <= result.currentIdx ) {
				$pgWrap.find('button.next').prop("disabled", true);
			}
			$pgWrap.find('button.prev').val(f);
			$pgWrap.find('button.next').val(result.resogetTotalNum);
		},
		listShow : function (data, listAmount, totalNum){
			//console.log(data);
			var HTML = conditionSelect.html;
			var M_HTML = conditionSelect.mobileHtml;
			//var i = conditionSelect.pcIdx;
			var i = 0;
			var icon_cls = "";
			var icon_title = "";
			
			//LGCOMIL-91 Start
			var downloadTxt = 'DOWNLOAD';
			if(!!$('.manual-software').data('messageDownload') && 'DOWNLOAD' != $('.manual-software').data('messageDownload')) {
				downloadTxt = $('.manual-software').data('messageDownload');
			}
			//LGCOMIL-91 End
			
			//console.log("i >> "+i);
			for(i;i<data.length;i++){
				if ( data[i].file_type ==='PDF'){ icon_cls = "icon-pdf";}
				else if ( data[i].file_type ==='ZIP'){ icon_cls = "icon-zip"; }
				else if ( data[i].file_type ==='TXT'){ icon_cls = "icon-txt"; }
				else if ( data[i].file_type ==='HTML'){ icon_cls = "icon-html"; }
				else if ( data[i].file_type ==='DJVU'){ icon_cls = "icon-djvu"; }
				else if ( data[i].file_type ==='DWG'){ icon_cls = "icon-dwg"; }
				else { icon_cls = "icon-etc"; }
				
				icon_title = data[i].file_type;
				
				HTML = HTML.add( 
					'<tr><td class="text-left"><span class="wrap-country-img">' + '<img data-src="'+(data[i].flag_name)+'" src="'+ (data[i].flag_name) +'" class="img-country" alt="'+(data[i].country_name)+'"> '
					+(data[i].country_name)+'</span></td><td>'
					+(data[i].resource_name)+'</td><td class="text-left"><p class="ellipsis">'
					+(data[i].file_name)+'</p></td><td>'/*'<td class="td-path">'
					+(data[i].gnb_path)+'</td><td>'*/ /* BTOBGLOBAL-760 */
					+(data[i].last_update_date)+'</td><td>'
					+'<a href="'+(data[i].file_f_url)+'" target="_blank" title="'+icon_title+' Download file" class="download-link '+icon_cls+'" download="'+(data[i].file_name)+'"><span class="download-link-text">'+downloadTxt+'</span></a>'+'</td><td>' //LGCOMIL-91
					+(data[i].file_size)+'</td></tr>'
				);
				
			}
			//console.log(HTML);      
			$('.table-list tbody').empty().append(HTML);
			//var j = conditionSelect.mobileIdx;
			var j = 0;
			for(j;j<data.length;j++){
				if ( data[j].file_type ==='PDF'){ icon_cls = "icon-pdf";}
				else if ( data[j].file_type ==='ZIP'){ icon_cls = "icon-zip"; }
				else if ( data[j].file_type ==='TXT'){ icon_cls = "icon-txt"; }
				else if ( data[j].file_type ==='HTML'){ icon_cls = "icon-html"; }
				else if ( data[j].file_type ==='DJVU'){ icon_cls = "icon-djvu"; }
				else if ( data[j].file_type ==='DWG'){ icon_cls = "icon-dwg"; }
				else { icon_cls = "icon-etc"; }
				
				icon_title = data[j].file_type;
				
				M_HTML = M_HTML.add(
					'<li class="list-item"><dl class="detail-item"><dt class="em">'+conditionSelect.country_m+'<span class="spacer">:</span></dt>'
					+'<dd class="desc">'+ '<img data-src="'+(data[j].flag_name)+'" src="'+ (data[j].flag_name) +'" class="img-country" alt="'+(data[j].country_name)+'"> '+(data[j].country_name)+'</dd></dl>'
					+'<dl class="detail-item long-text"><dt class="em">'+conditionSelect.resource_m+'<span class="spacer">:</span></dt>'
					+'<dd class="desc">'+(data[j].resource_name)+'</dd></dl>'
					+'<dl class="detail-item long-text"><dt class="em">'+conditionSelect.title_m+'<span class="spacer">:</span></dt>'
					+'<dd class="desc">'+(data[j].file_name)+'</dd></dl>'
					/*+'<dl class="detail-item long-text"><dt class="em">'+conditionSelect.path_m+'<span class="spacer">:</span></dt>'
					+'<dd class="desc">'+(data[j].gnb_path)+'</dd></dl>'*/ /* BTOBGLOBAL-760 */
					+'<dl class="detail-item"><dt class="em">'+conditionSelect.regdate_m+'<span class="spacer">:</span></dt>'
					+'<dd class="desc">'+(data[j].last_update_date.slice(0,10))+'</dd></dl>'
					+'<a href="'+(data[j].file_f_url)+'" target="_blank" title="'+icon_title+' Download file" class="download-link '+icon_cls+'" download="'+(data[j].file_name)+'"><span class="download-link-text" download>'+downloadTxt+'</span><span class="file-size">('+(data[j].file_size)+')</span></a>' //LGCOMIL-91
					+'</li>'
				);
			};
			// if( data.length < listAmount){
			// 	$('.expander').hide();
			// }
			$('.list-mobile').empty().append(M_HTML);
			if( listAmount >= totalNum){
				$('.data-page-length').text(totalNum);
				$('.expander').hide();
			}else{
				$('.data-page-length').text(listAmount);
				$('.expander').show();
			}
			$('.data-length').text(totalNum);
		}
	}
	conditionSelect.init();	
});


// LGEGMC-946
function setClassificationCode(categoryId){
	if(typeof standardData != 'undefined'){
		var url = '/'+COUNTRY_CODE.toLowerCase()+'/mkt/ajax/retrieveCategoryBuInfo?bizType=B2B&categoryId='+categoryId;
		$.ajax({
			type:"post",
			url: url,
			dataType: "json",
			xhrFields: {
				withCredentials: true
			},
			success: function(data) {
				standardData.level1 = data.data[0].buName.buName1;
				standardData.level2 = data.data[0].buName.buName2;
				standardData.level3 = data.data[0].buName.buName3;
			},
			error: function(request,status,error) {
				console.log("status: "+status);
				console.log("error: "+error);
			}
		});
	}
}
// LGEGMC-946 End